import { COLLECTIONS } from "constants/action-types";

export const fetchBrand = (payload) => ({ payload, type: COLLECTIONS.COLLECTION_SIDE_PANEL.BRAND.FETCH.START });
export const fetchBrandSuccess = () => ({ type: COLLECTIONS.COLLECTION_SIDE_PANEL.BRAND.FETCH.COMPLETED });
export const fetchBrandError = () => ({ type: COLLECTIONS.COLLECTION_SIDE_PANEL.BRAND.FETCH.COMPLETED });
export const fetchBrands = (options = {}) => {
    return {
        type: COLLECTIONS.COLLECTION_SIDE_PANEL.BRANDS.FETCH.START,
        payload: options,
    };
};
export const fetchBrandsSuccess = (payload) => ({
    payload,
    type: COLLECTIONS.COLLECTION_SIDE_PANEL.BRANDS.FETCH.COMPLETED,
});
export const fetchBrandsError = (payload) => ({
    error: true,
    payload,
    type: COLLECTIONS.COLLECTION_SIDE_PANEL.BRANDS.FETCH.COMPLETED,
});
export const cancelFetchBrands = () => ({ type: COLLECTIONS.COLLECTION_SIDE_PANEL.BRANDS.FETCH.CANCEL });
export const fetchSingleBrand = (brandId, forceNotFound = false) => {
    return {
        type: COLLECTIONS.COLLECTION_SIDE_PANEL.SINGLE_BRAND.FETCH.START,
        payload: { brandId, forceNotFound },
    };
};
export const fetchSingleBrandError = () => ({ type: COLLECTIONS.COLLECTION_SIDE_PANEL.SINGLE_BRAND.FETCH.COMPLETED });
